import { FC } from "react";
import GlobalUploadToaster from "src/modules/admin/components/inventory/components/asset-upload-progress-toaster/global-upload-toaster.component";
import GlobalAssetErrorModal from "src/modules/admin/components/inventory/components/asset-upload-progress-toaster/global-asset-error-modal.component";

const GlobalOverlays: FC = () => {
  return (
    <>
      {/* Global Upload Progress Toaster - persists across navigation */}
      <GlobalUploadToaster />
      
      {/* Global Asset Error Modal - persists across navigation */}
      <GlobalAssetErrorModal />
    </>
  );
};

export default GlobalOverlays;
